import deleteM from "./delete.js";
import findM from "./find.js";
import getM from "./get.js";
import initM from "./init.js";
import saveM from "./save.js";
import searchM from "./search.js";

export default (app) => {
  deleteM(app);
  findM(app);
  getM(app);
  initM(app);
  saveM(app);
  searchM(app);

  app.database.on(
    "init",
    ({ contentType, inited }) => {
      if (inited) return;
      const db = { dbArray: [], dbIndex: {} };

      const collection = app.addeventhandler(
        { contentType },
        ["aggregate", "delete", "find", "get", "init", "save", "saveFile", "search", "size", "update", "updates"],
        `database ${contentType.machinename}`,
      );

      collection.on("init", () => {
        const { dbArray, dbIndex } = db;
        dbArray.forEach((item) => {
          if (dbIndex[item._id]) dbArray.splice(dbArray.indexOf(dbIndex[item._id]), 1);
          dbIndex[item._id] = item;
        });
      });

      collection.on("size", () => db.dbArray.length);
      collection.on("aggregate", ({ filterField, filterValue, groupBy, sum }) => {
        const result = {};
        for (const data of db.dbArray)
          if (data[filterField] === filterValue && data[groupBy])
            result[data[groupBy]] = (result[data[groupBy]] || 0) + (Number(data[sum]) || 0);
        return result;
      });
      return { collection, db, contentType, inited: true, memdb: true };
    },
    1000,
  );
};
